import {
  ToastProvider as UiToastProvider,
  useToast,
  type Tone,
} from "@iluvatar/ui-kit";
import type { PropsWithChildren } from "react";

type ToastOptions = {
  variant?: "default" | "success" | "error" | "warning" | "info";
  autoHideDuration?: number | null;
  persist?: boolean;
};
export function ToastProvider({ children }: PropsWithChildren) {
  return <UiToastProvider maxToasts={5}>{children}</UiToastProvider>;
}
export function useToastContext() {
  const toast = useToast();
  return {
    addToast(message: string, options?: ToastOptions) {
      const tone: Tone =
        options?.variant === "error"
          ? "danger"
          : options?.variant === "default"
            ? "neutral"
            : options?.variant || "neutral";
      toast(message, {
        tone,
        duration: options?.persist ? 0 : (options?.autoHideDuration ?? 4000),
      });
    },
  };
}
